import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
  selector: "search-responder-license-types",
  templateUrl: "./search-responder-license-types.component.html",
  styleUrls: ["./search-responder-license-types.component.css"]
})
export class SearchResponderLicenseTypesComponent implements OnInit {

  @Output()
  search = new EventEmitter();
  formGroupSearch: FormGroup;
  isSearching: boolean = false;

  constructor(private _formBuilder: FormBuilder) {
    this.formGroupSearch = this._formBuilder.group({
      searchName: [""],
      searchCode: [""]
    });
  }

  ngOnInit() {
  }

  onKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      this.onSearchClick();
    }
  }

  onSearchClick() {
    this.isSearching = true;
    const valueEmit = Object.assign({}, this.formGroupSearch.value);
    this.search.emit(valueEmit);
  }

  onSearchComplete() {
    this.isSearching = false;
  }
  
}
